<!--
~ Copyright (c) RECREWT GmbH 2022.
-->

<mat-form-field
  (click)="open($event)"
  [class.remove-form-border]="!editable"
  class="container clear-infix"
  fxFlex="grow"
  >
  <mat-error>{{ 'COMMON.required' | translate }}</mat-error>
  <mat-chip-grid #chipList aria-label="Chip selection">
    @for (value of fromPredefined; track value; let i = $index) {
      <mat-chip-row
        (click)="chipClick.emit({ predefined: true, value: value, i: i })"
        (removed)="remove(value)"
        [class.primary]="true"
        [class.unclickable]="!editable"
        [removable]="(deletableInViewMode || editable) && (value | fn: isDeleteDisabled) === false"
        class="mat-body-1"
        color="accent"
        >
        @if (false) {
          <mat-icon matChipAvatar>star</mat-icon>
        }
        @if (optionTpl) {
          <ng-template *ngTemplateOutlet="optionTpl; context: { $implicit: value, idx: value | fn: indexOf }"
           />
        } @else {
          {{ value | translate }}
        }
        @if ((deletableInViewMode || editable) && (value | fn: isDeleteDisabled) === false) {
          <mat-icon
            matChipRemove
            >cancel</mat-icon
            >
          }
        </mat-chip-row>
      }
      @for (value of fromCustom; track value; let i = $index) {
        <mat-chip-row
          (click)="chipClick.emit({ predefined: false, value: value, i: i + fromPredefined.length })"
          (removed)="remove(value)"
          [class.primary]="true"
          [class.unclickable]="!editable"
          [removable]="(deletableInViewMode || editable) && (value | fn: isDeleteDisabled) === false"
          class="mat-body-1"
          color="accent"
          >
          @if (false) {
            <mat-icon matChipAvatar
              >star</mat-icon
              >
            }
            {{ value | translate }}
            @if ((deletableInViewMode || editable) && (value | fn: isDeleteDisabled) === false) {
              <mat-icon
                matChipRemove
                >cancel</mat-icon
                >
              }
            </mat-chip-row>
          }
          <!-- Rendered even while collapsed: without a registered matChipInputFor, mat-chip-grid
               throws from its `focused` getter on every change detection cycle, which aborts the
               pass and leaves the autocomplete panel (and everything after it) unrendered. -->
          <input
            #valueInput
            (matChipInputTokenEnd)="add($event)"
            [formControl]="searchCtrl"
            [matAutocomplete]="auto"
            [matChipInputFor]="chipList"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [maxlength]="maxLength"
            [style.display]="editable ? null : 'none'"
            matInput
            />
          @if (!editable) {
            <mat-chip-row
              (click)="open($event)"
              class="placeholder mat-body-1"
              color="accent"
              >
              {{ 'COMMON.add' | translate }}
              <mat-icon matChipTrailingIcon>add</mat-icon>
            </mat-chip-row>
          }
          @if (editable) {
            <mat-hint align="end" class="mat-caption"
              >{{ searchCtrl.value?.length || 0 }}/{{ maxLength }}</mat-hint
              >
            }
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
            @for (value of filteredPredefined | async; track value) {
              <mat-option
                [disabled]="value | fn: isDisabled:disabledOptions"
                [value]="value"
                >
                @if (!optionTpl) {
                  {{ value | translate }}
                }
                <ng-template *ngTemplateOutlet="optionTpl!; context: { $implicit: value, idx: value | fn: indexOf }"
                 />
                @if (value | fn: isDisabled:disabledOptions) {
                  <span class="p-l-s">
                    - {{ disabledOptionSuffix | translate }}
                  </span>
                }
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
